import React from 'react';
import Select from 'react-select'; 
import PropTypes from 'prop-types';

import dropdownStyles from '../styles/components/dropdown.module.scss';

const Dropdown = ({options, label, onChange, defaultValue, disabled, dropdownKey, value}) => {
    
    const disabledStyle = disabled ? dropdownStyles.__disabled : '';

    const customStyles = {
        menuPortal: (styles) => ({
            ...styles,
            zIndex: 999
        }),
        control: () => ({
            border: '1px solid #d9d9d9',
            borderRadius: '4px',
            width: '100%',
            height: '40px',
            display: 'flex',
            cursor: disabled ? 'not-allowed' : 'pointer'
        }),
        option: (provided, { isFocused, isSelected }) => ({
            ...provided,
            ':active': {
                backgroundColor: '#e6e6e6'
            },
            backgroundColor: isSelected ? '#e6e6e6' : 'white',
            ':hover': {
                backgroundColor: '#e6e6e6'
            },
            cursor: disabled ? 'not-allowed' : 'pointer',
            height: '40px',
        })
    }

    
    const formatOptionLabel = ({value, label}) => 
        <div className={dropdownStyles.__option}>{label}
        </div>

    return (
        <>
            <h4 style={{textAlign: 'left'}}>
                {label}
            </h4>
            <Select 
                key={dropdownKey ? dropdownKey : 'dropdown'}
                menuPlacement="bottom"
                menuPortalTarget={document.body}
                isSearchable={false}
                formatOptionLabel={formatOptionLabel}
                className={[dropdownStyles.__selector, disabledStyle].join(' ')}
                styles={customStyles}
                onChange={onChange}
                options={options}
                value={value}
                defaultValue={defaultValue}
                isDisabled={disabled}/>
        </>
    )

}

Dropdown.propTypes = {
    options: PropTypes.array.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    defaultValue: PropTypes.any,
    dropdownKey: PropTypes.string
}


export default Dropdown